import { Button } from "antd";
import React, { useEffect, useState } from "react";

import info from "../../../assets/icons/info-circle.svg";
import add from "../../../assets/icons/add-circle2.png";
import AudienceItem from "./AudienceItem";

// `numberOfAudiences` prop wont be needed, after we get the data from backend
export default function IncludedExcludedAudiences({ audienceType, audiences, scrollValue, onAdd, onDelete, setCombLogic, combLogic = "union", onChangeLogic }) {

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setCombLogic && setCombLogic(value); 
    onChangeLogic && onChangeLogic(audienceType, value);  
  };

  return (
    <div style={{ backgroundColor: "#F6F5FD", border: "1px solid #E0DDF7", borderRadius: 10, padding: "10px 20px 0 20px" }}>
      <p style={{ fontSize: 14, textTransform: "capitalize", marginBottom: 15, fontWeight: 500 }}>{audienceType} Audience</p>

      {/* Combination Logic must be shown when we have more than 1 audience */}
      {audiences.length > 1 && (
        <>
          <p style={{ fontSize: 14, marginBottom: 10 }}>Combination Logic:</p>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <label htmlFor={`union-${audienceType}`} style={{ display: "flex", alignItems: "center", gap: 5 }} className="gender-radio">
              <input type="radio" name={`combination-logic-${audienceType}`} id={`union-${audienceType}`}  value="union" 
                style={{ accentColor: "#6B43B5", width: 15 }} 
                checked={combLogic === "union"}
                onChange={handleRadioChange}
              />
              <span>Union</span>
              <img src={info} alt="info" style={{ width: 15 }} />
            </label>

            <label htmlFor={`common-${audienceType}`} style={{ display: "flex", alignItems: "center", gap: 5 }} className="gender-radio">
              <input type="radio" name={`combination-logic-${audienceType}`} id={`common-${audienceType}`}  value="common" 
                style={{ accentColor: "#6B43B5", width: 15 }} 
                checked={combLogic === "common"}
                onChange={handleRadioChange}
              />
              <span>Common</span>
              <img src={info} alt="info" style={{ width: 15 }} />
            </label>
          </div>
        </>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        {audiences.map((audience) => (
          <AudienceItem key={audience.id} scrollValue={scrollValue} audience={audience} onDelete={onDelete}/>
        ))}
      </div>

      <div style={{ width: "100%" }}>
        <Button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            gap: 10,
            padding: "20px 0",
            margin: "10px 0",
            backgroundColor: "transparent",
            border: "none",
          }}
          onClick={() => onAdd(audienceType)}
        >
          <img src={add} style={{width: 18, height: 18}} alt="plus" />
          <span style={{ color: "#6b43B5", fontSize: 14, textTransform: "capitalize" }} >
            Add {audienceType} Audience
          </span>
        </Button>
      </div>
    </div>
  );
}
